import { Dialog, DialogContent } from '@/components/shadcn/dialog'
import { ServiceModuleType } from '@/api/model/serviceModuleType'
import { EditLeaderboardServiceModule } from '../edit-components/leaderboard/EditLeaderboardServiceModule'
import { EditTextServiceModule } from '../edit-components/text/EditTextServiceModule'
import { EditUrlServiceModule } from '../edit-components/url/EditUrlServiceModule'
import { EditFileServiceModule } from '../edit-components/file/EditFileServiceModule'
import { EditDefaultServiceModule } from '../edit-components/default/EditDefaultServiceModule'
import type { LeaderboardServiceModuleModel, ServiceModuleModel } from '@/api/model'
import {
  EditInsuranceServiceModule
} from "@/pages/service-modules/edit-components/insurance/EditInsuranceServiceModule.tsx";
import {EditAbsenceServiceModule} from "@/pages/service-modules/edit-components/absence/EditAbsenceServiceModule.tsx";
import {
  EditPersonalDocumentsServiceModule
} from "@/pages/service-modules/edit-components/personal-documents/EditPersonalDocumentsServiceModule.tsx";

interface Props {
  module: ServiceModuleModel
  onClose: () => void
  modules: ServiceModuleModel[]
}

/**
 * Editor shell: provides only the dialog frame and picks the matching form based
 * on the module type. Each form brings its own header, columns and saving via its
 * type-specific endpoint. A new type with specifics =
 * new `*ModuleEditForm` file + a branch here.
 */
export function EditServiceModule({ module, onClose, modules }: Props) {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-4xl!">
        {renderForm()}
      </DialogContent>
    </Dialog>
  )

  function renderForm() {
    switch (module.type) {
      case ServiceModuleType.Leaderboard:
        return <EditLeaderboardServiceModule module={module as LeaderboardServiceModuleModel} onClose={onClose} />
      case ServiceModuleType.Text:
        return <EditTextServiceModule module={module} onClose={onClose} />
      case ServiceModuleType.Url:
        return <EditUrlServiceModule module={module} onClose={onClose} />
      case ServiceModuleType.File:
        return <EditFileServiceModule module={module} onClose={onClose} />
      case ServiceModuleType.Insurance:
        return <EditInsuranceServiceModule module={module} onClose={onClose} />
      case ServiceModuleType.Absence:
        return <EditAbsenceServiceModule module={module} onClose={onClose} />
      case ServiceModuleType.PersonalDocuments:
        return <EditPersonalDocumentsServiceModule module={module} onClose={onClose} />
      default:
        return <EditDefaultServiceModule module={module} onClose={onClose} modules={modules} />
    }
  }
}
